import React from 'react';
import styled from 'styled-components';
import { Box } from '@waglabs/box-next';
const Button = (props) => {
    const { children, disabled, href, size, variant, onClick, ...rest } = props;
    /**
     * ! TODO: remove ternary if possible
     * (see https://github.com/waglabs/wag-react/pull/197#discussion_r421910356)
     */
    return href ? (React.createElement(Box, Object.assign({ as: "a", alignItems: "center", cursor: "pointer", display: "inline-flex", fontFamily: "muli", fontWeight: "700", href: href, justifyContent: "center", lineHeight: "normal", minWidth: "64px", textDecoration: "none" }, sizeStyles(props)[size], variantStyles[variant], rest),
        React.createElement(Box, { as: "span", color: "inherit", cursor: "inherit", display: "flex", fontFamily: "inherit", fontSize: "inherit", fontWeight: "inherit", lineHeight: "inherit" }, children))) : (React.createElement(Box, Object.assign({ as: "button", alignItems: "center", cursor: "pointer", disabled: disabled, display: "inline-flex", fontFamily: "muli", fontWeight: "700", justifyContent: "center", lineHeight: "normal", minWidth: "64px", outline: "none", textDecoration: "none", onClick: onClick }, sizeStyles(props)[size], variantStyles[variant], rest),
        React.createElement(Box, { as: "span", color: "inherit", cursor: "inherit", display: "flex", fontFamily: "inherit", fontSize: "inherit", fontWeight: "inherit", lineHeight: "inherit" }, children)));
};
const variantStyles = {
    contained: {
        bg: 'wagGreen',
        border: 'none',
        borderRadius: '8px',
        color: 'white',
        fontWeight: '700',
    },
    text: {
        bg: 'transparent',
        color: 'wagGreen',
        border: 'none',
        fontWeight: '400',
        minHeight: 'initial',
        px: 0,
        py: 0,
    },
    outlined: {
        bg: 'transparent',
        color: 'wagGreen',
        border: '2px solid',
        borderColor: 'wagGreen',
        borderRadius: '8px',
        fontWeight: '700',
    },
};
const sizeStyles = ({ variant }) => ({
    small: {
        fontSize: ['14px', '16px'],
        minHeight: '36px',
        px: '24px',
        py: variant === 'outlined' ? '6px' : '8px',
    },
    medium: {
        fontSize: ['14px', '16px'],
        minHeight: '40px',
        px: '24px',
        py: variant === 'outlined' ? '8px' : '10px',
    },
    large: {
        fontSize: ['18px', '22px'],
        minHeight: '48px',
        px: '28px',
        py: variant === 'outlined' ? ['10px', '8px'] : ['12px', '10px'],
    },
    extraLarge: {
        fontSize: '20px',
        lineHeight: '24px',
        minHeight: '56px',
        px: '32px',
        py: variant === 'outlined' ? '14px' : '16px',
    },
});
const StyledButton = styled(Button).attrs(({ size = "medium", variant = 'text', }) => ({
    size,
    variant,
})) `
  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 1;
  }

  &:disabled {
    cursor: not-allowed;
    pointer-events: none;
  }

  ${({ theme, variant, }) => {
    switch (variant) {
        case 'contained': {
            return `
          &:disabled {
            background: ${theme.colors.lightGrey};
            color: ${theme.colors.wagGray};
          }
        `;
        }
        case 'outlined': {
            return `
          &:disabled {
            border-color: ${theme.colors.wagGray};
            color: ${theme.colors.wagGray};
          }
        `;
        }
        case 'text': {
            return `
          &:disabled {
            color: ${theme.colors.wagGray};
          }
        `;
        }
    }
}}
`;
export { StyledButton as Button };
